<script lang="ts">
    import { _ } from 'svelte-i18n';

    import ButtonSmallBlueRounded from '../../../shared/ButtonSmallBlueRounded.svelte';
    import IconMoreVertRounded from '../../../shared/Icons/IconMoreVertRounded.svelte';
    import { type AvailableContextMenuModeType, MenuContextCustomActions } from '../MenuContextCustomActions';
    import IconMoreVert from '../../../shared/Icons/IconMoreVert.svelte';
    import { MenuContextFactory } from './MenuContextFactory';
    import Opacity from '../../../shared/Opacity.svelte';

    export let menu: MenuContextCustomActions;
    export let displayMode: 'icon' | 'text' | 'button' = 'icon';
    export let disabled: boolean = false;
    export let menuMode: AvailableContextMenuModeType = 'menu';

    export let iconSymbol: any = IconMoreVert;
</script>

{#if displayMode === 'icon'}
    <Opacity opacity={disabled ? 0.5 : 1}>
        <svelte:component this={iconSymbol} scale={0.7} on:click={e => {
            if (disabled) { console.warn('disabled click'); return; }
            MenuContextFactory.set(menu);
            MenuContextFactory.setCoords(e.clientX, e.clientY);
            MenuContextFactory.open(menuMode);
        }} />
<!--    <IconMoreVert-->
<!--        scale={0.7}-->
<!--        on:click={e => {-->
<!--            if (disabled) { console.warn('disabled click'); return; }-->
<!--            MenuContextFactory.set(menu);-->
<!--            MenuContextFactory.setCoords(e.clientX, e.clientY);-->
<!--            MenuContextFactory.open();-->
<!--        }}-->
<!--    />-->
    </Opacity>
{:else if displayMode === 'text'}
    <Opacity opacity={disabled ? 0.5 : 1}>
    <IconMoreVertRounded
        scale={0.7}
        on:click={e => {
            if (disabled) { console.warn('disabled click'); return; }
            MenuContextFactory.set(menu);
            MenuContextFactory.setCoords(e.clientX, e.clientY);
            MenuContextFactory.open(menuMode);
        }}
    />
    </Opacity>
{:else if displayMode === 'button'}
    <ButtonSmallBlueRounded
        {disabled}
        colorMode="black"
        text={$_('Change') + '...'}
        margin="0 3px"
        on:click={e => {
            if (disabled) { console.warn('disabled click'); return; }
            MenuContextFactory.set(menu);
            MenuContextFactory.setCoords(e.clientX, e.clientY);
            MenuContextFactory.open(menuMode);
        }}
    />
{/if}
